module.exports = __webpack_public_path__ + "img/plsblogo2.43ae61b0.png";